class GlobalListeners {
  constructor() {
    this.selectors = {
      quickAdds: '[quick-add-qf]',
      productForms: '[action="/cart/add"]:not(.ctl-product-form [action="/cart/add"])',
      openSideCart: '.openSideCart',
      closeSideCart: '.closeSideCart',
      removeButtons: '.cart .items-wrapper .item .remove-item',
      quantitySelectorPlus: '.cart .items-wrapper .item .quantity-wrapper .plus',
      quantitySelectorMinus: '.cart .items-wrapper .item .quantity-wrapper .minus',
      cartCount: '.cart-count'
    }

    this.init();
  }

  init() {
    window.log("Initialising global QF listeners");
    let vm = this;
    document.body.addEventListener('click', function (e) {
      vm.productQuickAdd(e)
      vm.sideCart(e)
      vm.quantityButtons(e)
      vm.removeCartItem(e)
    })
    vm.productForm()
    vm.cartRelated()
    vm.headerSearch()
    vm.megaMenu()
    vm.mobileMenu()
    vm.pullouts()
  }

  productQuickAdd(e) {
    // PRODUCT QUICK ADD
    const quickAdd = e.target.closest(this.selectors.quickAdds);
    if (quickAdd) {
      if (quickAdd.dataset.id && quickAdd.dataset.quantity && quickAdd.dataset.quantity > 0) {
        window.cart.add({ items: [{ "id": quickAdd.dataset.id, "quantity": quickAdd.dataset.quantity }] });

        // Update cart count on add
        let renderCartCount = () => {
          let cartCount = document.querySelectorAll(".cart-count");
          cartCount.forEach((count) => {
            count.innerHTML = window.cart.cart.items.length;
          })
        }
        window.addEventListener("cart_changed", renderCartCount);
      }
    }
  }

  productForm() {
    // PRODUCT FORM LISTENER
    let productForms = document.querySelectorAll(this.selectors.productForms);
    for (let i = 0; i < productForms.length; i++) {
      let productForm = productForms[i];
      productForm.addEventListener("submit", function (e) {
        e.preventDefault();
        let quantity = productForm.querySelector("input.quantity-selector").value;
        let id = productForm.querySelector("#product-id").value;
        if (quantity && id) {
          window.cart.add({ items: [{ "id": id, "quantity": quantity }] });
        }

        // Update cart count on add
        let renderCartCount = () => {
          let cartCount = document.querySelectorAll(".cart-count");
          cartCount.forEach((count) => {
            count.innerHTML = window.cart.cart.items.length;
          })
        }
        window.addEventListener("cart_changed", renderCartCount);
      });
    }
  }

  sideCart(e) {
    // SITE CART OPEN AND CLOSE
    if (window.QF.settings.sideCart) {
      const openSideCart = e.target.closest(this.selectors.openSideCart);
      if (openSideCart) {
        e.preventDefault();
        window.cart.openSideCart();
      }

      const closeSideCart = e.target.closest(this.selectors.closeSideCart);
      if (closeSideCart) {
        e.preventDefault();
        window.cart.closeSideCart();
      }
    }
  }

  quantityButtons(e) {
    // QUANTITY PLUS CART
    const quantityPlus = e.target.closest(this.selectors.quantitySelectorPlus)
    if (quantityPlus) {
      if (quantityPlus.getAttribute("data-pending") == "true") return false;
      quantityPlus.setAttribute("data-pending", true);

      let quantity = quantityPlus.parentNode.querySelector(".quantity span");
      let stock = quantity.getAttribute("data-stock");
      let variant_id = quantity.getAttribute("data-variant-id");
      let inv_policy = quantity.getAttribute("data-inventory-policy");
      if (inv_policy == "continue" || stock > 0) {
        // if in stock or continue selling when out of stock, update cart
        window.cart.add({ items: [{ "id": variant_id, "quantity": quantity }] });
      }
    }

    // QUANTITY MINUS CART
    const quantityMinus = e.target.closest(this.selectors.quantitySelectorMinus)
    if (quantityMinus) {
      if (quantityMinus.getAttribute("data-pending") == "true") return false;
      quantityMinus.setAttribute("data-pending", true);

      let quantity = quantityMinus.parentNode.querySelector(".quantity span");
      let current = parseInt(quantity.innerHTML);
      let variant_id = quantity.getAttribute("data-variant-id");

      if (current > 0) {
        let updated = current - 1;
        window.cart.update({ updates: { [variant_id]: updated } });
      }
    }
  }

  removeCartItem(e) {
    // REMOVE ITEM CART
    const removeButtons = e.target.closest(this.selectors.removeButtons)
    if (removeButtons) {
      let variant_id = removeButtons.getAttribute("data-variant-id");
      window.cart.remove(variant_id)
    }
  }

  cartRelated() {
    // update side cart/cart after change
    let renderCarts = () => {
      if (window.template == "cart") {
        window.cart.reRenderCart();
      } else {
        if (window.QF.settings.ajax_open_side_cart) {
          window.cart.openSideCart();
        } else if (window.QF.settings.ajax_toast) {
          window.cart.reRenderSideCart();
        }
      }
    };
    window.addEventListener("cart_changed", renderCarts);
    window.addEventListener("item_removed", renderCarts);

    // CART COUNT
    window.addEventListener("cart_changed", (e) => {
      if (e.detail.cart) {
        let cartCount = document.querySelectorAll(".cart-count");
        cartCount.forEach((count) => {
          count.innerHTML = e.detail.cart.item_count;
        })
      }
    })
  }

  // HEADER SEARCH
  headerSearch(e) {
    const search = document.querySelector('.mega-menu-search');
    const searchTrigger = document.querySelectorAll('[data-open-search]');
    const searchCloseTrigger = document.querySelector('[data-close-search]');
    const searchInput = document.querySelector('.search-bar-qf input');
    const getHeader = document.querySelector('.mega-menu-outer-shopify-wrapper');

    const megaMenu = document.querySelector('.mega-menu');
    const megaMenuClose = document.querySelector('.closeMenu');

    const topLinks = document.querySelectorAll('.js-top-level-link');

    // Check Search exists
    if (search) {
      // Open / Close Search
      searchTrigger.forEach((el) => {

        el.addEventListener('click', function (e) {

          topLinks.forEach((otherLink) => {
            otherLink.classList.remove('active');
            const nextDiv = otherLink.nextElementSibling;
            if (nextDiv && nextDiv.classList.contains('mega-menu-dropdown_outer-wrapper')) {
              nextDiv.classList.remove('active');
            }
          });

          document.body.classList.toggle('search-active');
          getHeader.classList.toggle('is-search');

          search.scrollTo(0, 0);

          el.classList.toggle('active');
          search.classList.toggle('active');

          if (megaMenu.classList.contains('active')) {
            megaMenuClose.click();
          }


        });
      });

      // Close search with cross
      searchCloseTrigger.addEventListener('click', function (e) {
        document.body.classList.remove('search-active');
        getHeader.classList.remove('is-search');

        searchTrigger.forEach((el) => {
          el.classList.remove('active');
        });

        search.classList.remove('active');
      });

      // Close search with Escape Key
      window.addEventListener('keydown', function (e) {
        let key = e.key;

        if (key == 'Escape') {
          if (search.classList.contains('active')) {
            document.body.classList.remove('search-active');
            getHeader.classList.remove('is-search');
        
            searchTrigger.forEach((el) => {
              el.classList.remove('active');
            });
        
            search.classList.remove('active');
        
            // Apply display: none to elements with the class 'acs_auto_popup'
            document.querySelectorAll('.acs_auto_popup').forEach((popup) => {
              popup.style.display = 'none';
            });
          } else {
            return;
          }
        }
        
      });
    }

  }

  megaMenu(e) {
    const topLinks = document.querySelectorAll('.js-top-level-link');

    const search = document.querySelector('.mega-menu-search');
    const searchTrigger = document.querySelectorAll('[data-open-search]');
    const getHeader = document.querySelector('.mega-menu-outer-shopify-wrapper');

    if (topLinks) {
      topLinks.forEach((link) => {
        link.addEventListener('click', function(e) {
          e.preventDefault();

          document.body.classList.remove('search-active');
          getHeader.classList.remove('is-search');

          searchTrigger.forEach((el) => {
            el.classList.remove('active');
          });
  
          search.classList.remove('active');

          // Remove 'active' class from all previous elements
          topLinks.forEach((otherLink) => {
            if (otherLink !== link) {
              otherLink.classList.remove('active');
              const nextDiv = otherLink.nextElementSibling;
              if (nextDiv && nextDiv.classList.contains('mega-menu-dropdown_outer-wrapper')) {
                nextDiv.classList.remove('active');
              }
            }
          });

          // Toggle 'active' class on the clicked element
          link.classList.toggle('active');

          // Toggle 'active' class on the next div
          const nextDiv = link.nextElementSibling;
          if (nextDiv && nextDiv.classList.contains('mega-menu-dropdown_outer-wrapper')) {
            nextDiv.classList.toggle('active');
          }
        });
      });
    }
  }
  
  mobileMenu() {
    const menu = document.querySelector('.mobile-menu-outer-wrapper');
    const megaMenu = document.querySelector('.mega-menu');
    const menuTrigger = document.querySelector('#open-mobile-menu');

    if (!menu || !menuTrigger) {
        return;
    }

    // Toggle menu visibility
    const toggleMenu = (isOpen) => {
        document.body.classList.toggle('fixed', isOpen);
        menu.classList.toggle('active', isOpen);
        megaMenu.classList.toggle('active', isOpen);
        menuTrigger.classList.toggle('active', isOpen);
    };

    // Open/close menu on button click
    menuTrigger.addEventListener('click', () => {
        const isMenuOpen = menuTrigger.classList.contains('active');
        toggleMenu(!isMenuOpen);
    });

    // Close menu when clicking outside or on overlay
    menu.addEventListener('click', (e) => {
        if (e.target.classList.contains('mobile-menu-outer-wrapper')) {
            toggleMenu(false);
        }
    });

    // Close menu when a link is clicked
    const menuLinks = menu.querySelectorAll('a');
    menuLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
            const href = link.getAttribute('href');

            // If the link has a hash (e.g., "#section"), allow scrolling
            if (href.startsWith('#')) {
                toggleMenu(false);
            } else {
                toggleMenu(false);
            }
        });
    });

    // Handle submenus
    const menuItemsWithChildren = document.querySelectorAll('.top-level-link.has-children');
    menuItemsWithChildren.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            const submenu = item.nextElementSibling;
            if (submenu) {
                submenu.classList.toggle('active');
            }
        });
    });

    const submenuBackTitles = document.querySelectorAll('.sub-menu .dropdown-title');
    submenuBackTitles.forEach((item) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            const submenu = item.closest('.sub-menu');
            if (submenu) {
                submenu.classList.remove('active');
            }
        });
    });
}

  pullouts(e) {

    const pulloutOverlay = document.querySelector('.pullout-overlay');
    const openPullout = document.querySelectorAll('[data-open-pullout]');
    const closePullout = document.querySelectorAll('[data-close-pullout]');

    const pullouts = document.querySelectorAll('.pullout');

    openPullout.forEach((open) => {
      open.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.add('pullout-active');
        pulloutOverlay.classList.add('active');

        let thisID = open.getAttribute('data-open-pullout');
        if(thisID === 'location'){
          window.initLoadLocation(true,true)
        }
        const pullout = document.querySelector(`.pullout-${thisID}`);

        pullout.classList.add('active');
      })
    })

    // Close pullout
    closePullout.forEach((close) => {
      close.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.remove('pullout-active');
        pulloutOverlay.classList.remove('active');

        pullouts.forEach((pullout) => {
          pullout.classList.remove('active');
        });
      })
    })

    // If user creates account or logs in on choose location.
    if (window.location.search.includes('?location=true')) {
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelector('.header-select-location').click();
      });
    }

  }


}

window.GlobalListeners = GlobalListeners;